import { colors as defaultColors } from './colors';

// Type for a color palette preset
export interface ColorPalette {
  primary: typeof defaultColors.primary;
  secondary: typeof defaultColors.secondary;
  error?: typeof defaultColors.error;
  warning?: typeof defaultColors.warning;
  info?: typeof defaultColors.info;
  success?: typeof defaultColors.success;
  grey?: typeof defaultColors.grey;
  background?: typeof defaultColors.background;
  text?: typeof defaultColors.text;
}

// Default construction theme (yellow/gold)
export const constructionTheme: ColorPalette = {
  primary: defaultColors.primary,
  secondary: defaultColors.secondary,
  error: defaultColors.error,
  warning: defaultColors.warning,
  info: defaultColors.info,
  success: defaultColors.success,
  grey: defaultColors.grey,
  background: defaultColors.background,
  text: defaultColors.text,
};

// Export default theme
export const defaultTheme = constructionTheme;

// Function to create a custom theme preset
export const createThemePreset = (
  overrides: Partial<ColorPalette>
): ColorPalette => {
  return {
    ...defaultTheme,
    ...overrides,
  };
};